import { AppRegions } from './AppRegions.model'
import { Keyword } from './Keyword.model'
import { ParkingLot } from './ParkingLot.model'
import { Sponsor } from './Sponsor.model'
import { Trail } from './Trail.model'
import { USStates } from './USStates.model'
import { WeatherGroup } from './WeatherGroup.model'
import { WeatherRecord } from './WeatherRecord.model'

export type TrailSystem = {
  id: number
  region: AppRegions
  name: string
  trails?: Trail[]
  weatherGroups: (WeatherGroup & { priority: number })[]
  displayWeatherGroup?: WeatherGroup
  sponsor?: Sponsor
  mostRecentDisplayWeatherRecord?: WeatherRecord
  description: string // Currently unused and hidden in the UI; kept for potential future use
  parkingLots?: Partial<ParkingLot>[]
  street: string
  city: string
  state: USStates
  sortWeight: number
  permalink: string
  keywords?: Keyword[]
  active: boolean
  updatedAt: Date
  createdAt: Date
  trailStewards?: number[]
  precipitationLookbackDays?: number | null
  freezeThawEnabled?: boolean | null
  // Trailforks status pusher opt-in for this system. Boolean, defaults to false.
  // Trails inherit this unless they have their own trailforksSyncEnabled override.
  trailforksSyncEnabled: boolean
  // F7 — Comma-separated list of Trailforks region ids for the steward-closed pre-fetch.
  // Backend refuses to enable trailforksSyncEnabled without at least one populated id.
  trailforksRegionId?: string | null
  dryTimeModifier?: number | null
  saturationModifier?: number | null
}

// we offer this to enable the enumerate the TrailSystem type's fields in js/ts files
export const trailSystemFields: (keyof TrailSystem)[] = [
  'id',
  'name',
  'region',
  'weatherGroups',
  'displayWeatherGroup',
  'description',
  'parkingLots',
  'street',
  'city',
  'state',
  'sortWeight',
  'permalink',
  'keywords',
  'active',
  'updatedAt',
  'createdAt',
  'trailStewards',
  'precipitationLookbackDays',
  'freezeThawEnabled',
  'trailforksSyncEnabled',
  'trailforksRegionId',
  'dryTimeModifier',
  'saturationModifier',
]
